import { __rest } from "tslib";
import { jsx as _jsx } from "preact/jsx-runtime";
import styles from 'pathfinder/modules/InWikiEmailModule/components/styles/FadeIn.module.scss';
const FadeIn = (_a) => {
    var { duration = 300, delay = 0, children } = _a, delegated = __rest(_a, ["duration", "delay", "children"]);
    return (_jsx("div", Object.assign({ className: styles.wrapper }, delegated, { style: Object.assign(Object.assign({}, (delegated.style || {})), { animationDuration: duration + 'ms', animationDelay: delay + 'ms' }) }, { children: children }), void 0));
};
export default FadeIn;
